import React from 'react';
import Icon from '../../../components/openplay/OpenPlayIcon';

const ActivityFeed = ({ activities }) => {
  const getActivityColor = (type) => {
    switch (type) {
      case 'application':
        return 'bg-accent/10 text-accent';
      case 'inquiry':
        return 'bg-primary/10 text-primary';
      case 'completion':
        return 'bg-success/10 text-success';
      case 'review':
        return 'bg-warning/10 text-warning';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  return (
    <div className="bg-card rounded-xl border border-border p-4 shadow-elevation-1">
      <div className="space-y-4">
        {activities.map((activity) => (
          <div key={activity.id} className="flex gap-3">
            <div className={`flex items-center justify-center w-10 h-10 rounded-full flex-shrink-0 ${getActivityColor(activity.type)}`}>
              <Icon name={activity.icon} size={20} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm text-foreground">{activity.message}</p>
              <p className="text-xs text-muted-foreground mt-1 caption">{activity.timestamp}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityFeed;
